import React from "react";
import { Container } from "react-bootstrap";

// The caller owns field mapping and every business action. CSS owns all geometry.
export default function CourseHero({ titleLeft, title = "", summary, slogan, mediaSrc, fallbackSrc, cta }) {
    const words = title.trim().split(/\s+/);
    const heading = <h1 className="course-hero__title montserrat-alternates-bold">
        <span className="course-hero__title-first">{words[0]}</span>{" "}
        {words.length > 1 && <span className="course-hero__title-rest">{words.slice(1).join(" ")}</span>}
    </h1>;
    const sloganRegion = slogan?.trim() ? <div className="course-hero__slogan" dangerouslySetInnerHTML={{ __html: slogan }} /> : null;
    const summaryRegion = summary?.trim() ? <div className="course-hero__summary">{summary}</div> : null;

    return <section className={`course-hero course-hero--title-${titleLeft ? "left" : "right"}`}>
        <Container>
            <div className="course-hero__layout">
                <div className="course-hero__copy">
                    {heading}
                    {titleLeft && sloganRegion}
                    {summaryRegion}
                </div>
                <div className="course-hero__visual">
                    {!titleLeft && sloganRegion}
                    <div className="course-hero__art">
                        <img src={mediaSrc || fallbackSrc} alt={title || "course-gif"} onError={event => {
                            // A failed custom upload gets the same original fallback as a missing one.
                            if (event.currentTarget.getAttribute("src") !== fallbackSrc) event.currentTarget.src = fallbackSrc;
                        }} />
                    </div>
                </div>
            </div>
            <div className="course-hero__cta">{cta}</div>
        </Container>
        <div className="course-hero__wave" aria-hidden="true">
<svg height="90" viewBox="0 0 1440 90" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M344.52 26.4584L328.906 21.6816C280.198 6.78057 228.498 4.52681 178.678 15.1326L128.243 25.8695C115.406 28.6021 102.143 28.6375 89.292 25.9735L26.3649 12.928C3.21702 8.12926 -18.8226 24.9218 -20.3393 48.5131C-21.7803 70.9268 -3.98945 89.8981 18.4705 89.8981H1424.17C1450.38 89.8981 1470.99 67.516 1468.85 41.3987C1466.33 10.7862 1434.47 -8.28397 1406.3 3.96253L1347.94 29.3346C1330.35 36.9815 1310.78 38.8353 1292.07 34.6279L1194.22 12.6271C1154.25 3.63924 1112.74 4.03961 1072.95 13.7968L1053.46 18.5754C1022.86 26.0788 990.855 25.7272 960.427 17.5533C936.542 11.1372 911.621 9.52362 887.108 12.8059L803.523 23.9982C773.745 27.9855 743.537 27.4772 713.91 22.4901L679.995 16.7814C644.838 10.8635 608.908 11.2597 573.89 17.9512L488.59 34.2509C440.648 43.4121 391.195 40.7373 344.52 26.4584Z" fill="#222222" />
                </svg>
        </div>
    </section>;
}
